var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZerocostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5625,
    cy: 15,
    r: 15,
    fill: "#F7F9FA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 13.25,
    fill: "#09A3A9",
    stroke: "#09A3A9",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 19.7286L11.8644 21.8689C11.7038 21.9688 11.5359 22.0116 11.3607 21.9973C11.1855 21.9831 11.0322 21.926 10.9008 21.8261C10.7694 21.7262 10.6672 21.6015 10.5942 21.452C10.5212 21.3019 10.5066 21.1341 10.5504 20.9486L11.514 16.9035L8.29465 14.1854C8.14864 14.0569 8.05754 13.9106 8.02133 13.7462C7.98454 13.5824 7.99534 13.422 8.05374 13.265C8.11214 13.1081 8.19974 12.9797 8.31655 12.8798C8.43335 12.7799 8.59395 12.7157 8.79835 12.6872L13.047 12.3233L14.6895 8.51366C14.7625 8.34244 14.8758 8.21403 15.0294 8.12842C15.1824 8.04281 15.3392 8 15.4998 8C15.6604 8 15.8175 8.04281 15.9711 8.12842C16.1241 8.21403 16.2371 8.34244 16.3101 8.51366L17.9527 12.3233L22.2013 12.6872C22.4057 12.7157 22.5663 12.7799 22.6831 12.8798C22.7999 12.9797 22.8875 13.1081 22.9459 13.265C23.0043 13.422 23.0154 13.5824 22.9792 13.7462C22.9424 13.9106 22.851 14.0569 22.705 14.1854L19.4857 16.9035L20.4493 20.9486C20.4931 21.1341 20.4785 21.3019 20.4055 21.452C20.3325 21.6015 20.2303 21.7262 20.0989 21.8261C19.9675 21.926 19.8142 21.9831 19.639 21.9973C19.4638 22.0116 19.2959 21.9688 19.1353 21.8689L15.4998 19.7286Z",
    fill: "#E6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZerocostIcon);
export default __webpack_public_path__ + "static/media/zerocost_icon.7c070e42e1ad4a5bce9f69cb8a41a47d.svg";
export { ForwardRef as ReactComponent };